import { sinatraOrigin } from '../../config'

import keycloakService from '../../keycloak_service'

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const publishListPublishesForPipeline = (id) => {
  const body = {
    pipeline_id: id
  }
  const fetchOptions = {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  }

  return postToApi('v1/api/pipelines/list_publishes_for_pipeline', fetchOptions)
}

export const swrListPublishesForPipelineFetcher = (queryParams) => {
  const [pipelineId] = queryParams;

  return publishListPublishesForPipeline(pipelineId)
}

export default swrListPublishesForPipelineFetcher
